module.exports = __webpack_public_path__ + "static/media/more-grey-icon.a9bb9e7f.svg";